'use strict';

export default angular
  .module('maestro.filters.fromNow', [])

  .filter('fromNow', function($filter) {
    let $t = $filter('translate');
    return function(date, simple) {
      if (simple) {
        return moment(date).calendar(null, {
          sameDay: '[' + $t('datetime.today') + ']',
          lastDay: '[' + $t('datetime.yesterday') + ']',
          lastWeek: '[' + $t('datetime.last') + '] dddd',
          sameElse: function() {
            return '[' + moment(date).fromNow() + ']';
          }
        });
      }
      return moment(date).fromNow();
    };
  })

  .name;
